import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const ErrorIcon = React.forwardRef<SVGSVGElement, IconProps>(function ErrorIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" fillRule="evenodd" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-1 15v-2h2v2zm0-10v6h2V7z" clipRule="evenodd"/>
        </IconBase>
    );
});
